import { useEffect } from "react";
import styled from "styled-components";
import useGetMemberDetail from "../../hooks/useGetMemberDetail";
import theme from "../../theme";
import AuthField from "./authField";
import InputField from "./inputField";
import Spinner from "../spinner";
import { Button } from "../common/Button";
import { ModalLayout } from "../common/ModalLayout";
import { useWindowSize } from "@reactuses/core";
import { SystemSetting } from "../../types/types";
import { useI18n } from "../../locales";

const { md } = theme.screen;

const UserDetailModal: React.FC<{
  open: boolean;
  onPressNo: () => void;
  idx: number;
  setDetailData: any;
  onClickModify: any;
  isMyPage?: boolean;
  systemSetting: SystemSetting | null;
}> = (props) => {
  const {
    open,
    onPressNo,
    idx,
    setDetailData,
    onClickModify,
    isMyPage,
    systemSetting,
  } = props;
  const { data, isLoading } = useGetMemberDetail({ idx });
  const { width } = useWindowSize();
  const { t } = useI18n();

  useEffect(() => {
    if (data) {
      setDetailData(data);
    }
  }, [data]);

  return (
    <ModalLayout
      open={open}
      onClose={onPressNo}
      width="1300px"
      title={isMyPage ? t.manageUser.myAccountInfo : t.manageUser.userAccountInfo}
    >
      {isLoading && <Spinner />}
      {data && (
        <>
          <InputField data={data} />
          <Title>{t.manageUser.permissionManagement}</Title>
          <AuthField data={data} />
          {/*계정 기기 연동<DeviceField data={data} idx={idx} />*/}
          <BtnWrapper>
            <Button
              onClick={onClickModify}
              bgColor={theme.statusColor.MAIN}
              hoverColor={theme.statusColor.MAIN_HOVER}
              isDisabled={!systemSetting?.update}
            >
              {width <= md ? t.common.edit : t.manageUser.editUser}
            </Button>
            <Button
              bgColor={theme.statusColor.CLOSE}
              onClick={onPressNo}
              hoverColor={theme.statusColor.CLOSE_HOVER}
            >
              {t.common.close}
            </Button>
          </BtnWrapper>
        </>
      )}
    </ModalLayout>
  );
};

const Title = styled.div`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};
  padding-bottom: 20px;
  padding-left: 0px;
`;

const BtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 0 50px;
  margin-top: 20px;

  button {
    width: 270px;
  }

  @media (max-width: ${md}px) {
    margin: 0px;
    margin-top: 20px;
  }
`;

export default UserDetailModal;
